function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.47126 6.45765C3.92519 5.86995 3.01786 5.84741 2.44468 6.40732C1.87151 6.96722 1.84953 7.89753 2.3956 8.48523C2.3956 8.48523 10.953 17.5544 10.9778 17.5791C11.5692 18.1587 12.5068 18.137 13.072 17.5307L21.6027 8.48532C22.1498 7.89855 22.1293 6.9682 21.5571 6.40732C20.9848 5.84643 20.0774 5.86741 19.5304 6.45417L12.2029 14.0917C12.0927 14.2066 11.909 14.2066 11.7988 14.0918L4.47126 6.45765Z",
  fill: "#878793"
});

function SvgIconKeyboardArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKeyboardArrowDown);
export default __webpack_public_path__ + "static/media/icon-keyboard-arrow-down.f58bf8c4.svg";
export { ForwardRef as ReactComponent };